import { IReduxStore } from "Redux/Store/IReduxStore";

export const getSpotCount = (state: IReduxStore) =>
    state.spot.spot.maxCount;